<script lang="ts">
    import { MediaImageDocument, MediaImageFragmentDoc } from '$gql/graphql.js';
    import { useFragment } from '$gql/fragment-masking.js';
    import { query } from '$lib/apollo/SvelteApollo.js';

    export let mediaId: number;

    const { result, setVariables } = query(MediaImageDocument, {
        variables: { mediaId },
    });
    $: setVariables({ mediaId });

    $: media = useFragment(MediaImageFragmentDoc, $result.data?.media);

    function createUrlMedia(_media: typeof media) {
        return (format: string) => {
            if (_media == null) {
                return '';
            } else if (format === 'reference') {
                return _media.referenceUrl;
            } else {
                return _media.fakeUrl.replace('__fake__', format);
            }
        };
    }

    $: urlMedia = createUrlMedia(media);
</script>

{#if !$result.loading && media != null}
    <slot
        {urlMedia}
        alt={media.alt ?? null}
        title={media.title ?? null}
        width={media.width ?? null}
        height={media.height ?? null}
        context={media.context ?? null}
    />
{:else}
    <slot name="loading" />
{/if}
